import {call, put, select} from "redux-saga/effects";
import api from "../../services/api";
import {Creators as GerarRepassesActions} from "../ducks/gerarRepasses";
import {Creators as ModalActions} from "../ducks/modal";
import {Creators as ErrorActions} from "../ducks/error";
import {Creators as LoadingActions} from "../ducks/loading";
import moment from "moment";
import {formatReal} from "../../helpers";

export function* getListGerarRepasses() {
  try {
    yield put(LoadingActions.setLoading());
    const {filter} = yield select(state => state.gerarRepasses);
    filter.has_receipt =
      filter.has_receipt === "true"
        ? true
        : filter.has_receipt === "false"
        ? false
        : "";
    const {data} = yield call(
      api.post,
      `/comissions/generates`,
      filter
    );
    const {data: gerarRepasses} = data;
    let gerarRepassesPayload = [];
    gerarRepassesPayload = gerarRepasses.map(repasse => ({
      id: repasse.id,
      name: repasse.name,
      cpf_cnpj: repasse.cpf_cnpj ? repasse.cpf_cnpj : "",
      address: repasse.address,
      sales_count: repasse.sales_count,
      value_financed: formatReal(repasse.value_financed_total),
      value_released: formatReal(repasse.value_released_total),
      value_installment: formatReal(repasse.value_installment_total),
      value_base: formatReal(repasse.value_base_total),
      multiplier: formatReal(repasse.multiplier)
    }));
    yield put(
      GerarRepassesActions.getListGerarRepassesSuccess(gerarRepassesPayload)
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getGerarRepasses({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {filter} = yield select(state => state.gerarRepasses);
    filter.comissionable_id = payload.id;
    const {data} = yield call(
      api.post,
      `comissions/generates/comissions`,
      filter
    );
    const indexPrimeroRepasse = 0;
    const propostas = data.sales;
    const faixas_selects = data.faixas;
    data.sales = propostas.map(function (proposta) {
      let value_base_comissao = proposta.convenet.receipt_settings.length > 0
        ? proposta.convenet.receipt_settings[indexPrimeroRepasse]
          .comission_value === 1
          ? proposta.value_released
          : proposta.convenet.receipt_settings[indexPrimeroRepasse]
            .comission_value === 2
            ? proposta.value_financed
            : proposta.convenet.receipt_settings[indexPrimeroRepasse]
              .comission_value === 3
              ? proposta.value_installment
              : proposta.convenet.receipt_settings[indexPrimeroRepasse]
                .comission_value === 4
                ? proposta.value_debit
                : 0
        : 0;
      return {
        id: proposta.id,
        receipt_number: proposta.receipt_number,
        receipt_description: proposta.receipt_description,
        comission_value:
          proposta.convenet.receipt_settings.length > 0
            ? proposta.convenet.receipt_settings[indexPrimeroRepasse].comission_value
            : 0,
        date: proposta.date ? moment(proposta.date).format("DD/MM/YYYY") : "",
        accepted_at: proposta.accepted_at ? moment(proposta.accepted_at).format("DD/MM/YYYY") : "",
        comissionable_id: payload.id,
        convenet: proposta.convenet,
        bank: proposta.convenet.bank.name,
        product: proposta.convenet.product.name,
        operation: proposta.convenet.operation.name,
        contract_number: proposta.contract_number ? proposta.contract_number : "",
        number: proposta.sale_number && proposta.contract_number 
          ? `<span>P.&nbsp;${proposta.sale_number} <br/> C.&nbsp;${proposta.contract_number}</span>`
        : proposta.sale_number
        ? `<span>P.&nbsp;${proposta.sale_number}</span>`
        :proposta.contract_number 
        ? `<span>C.&nbsp;${proposta.contract_number}</span>`
        : "",
        customer: `<span>${proposta.customer.name} <br/> CPF: ${proposta.customer.cpf_cnpj}</span>`,
        customer_cpf_cnpj: proposta.customer.cpf_cnpj,
        value_debit: proposta.value_debit ? formatReal(proposta.value_debit) : "",
        value_base: value_base_comissao,
        column_used_to_base: "value_base_formated",
        total_receipted: proposta.total_receipted,
        percent_receipted: proposta.total_receipted > 0 && value_base_comissao > 0 ? ((proposta.total_receipted * 100) / value_base_comissao).toFixed(2) : 0,
        multiplier: (value_base_comissao * proposta.convenet.goals_percent) / 100,
        deadline: proposta.deadline,
        receipts_count: proposta.receipts_count,
        status: proposta.status[0]
          ? `<span class="td-color" style="color: #ffffff!important; max-width: 10rem;  cursor:context-menu; background-color:${
            proposta.status[0].color
          }">
          ${
            proposta.status[0].notes
                ? `<span class="tag-child">
            <span class="tag-row">${proposta.status[0].notes}</span>
          </span>`
              : ""
          }
            ${proposta.status[0].name}
          </span>`
          : "",
        docs:
          proposta.notes && !proposta.docs
            ? `<span class="s-docs docs-not-ok-warning"><span class='tag-child'><span class='tag-row'>Observações: ${
              proposta.notes
            }</span></span>
              ${
              proposta.files.length <= 0 &&
              proposta.customer.files.length <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }
              </span>`
            : proposta.docs
            ? `<span class="s-docs docs-ok"><span class='tag-child'><span class='tag-row'>Documentação Ok</span></span>${
              proposta.files.length <= 0 && proposta.customer.files.length <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }</span>`
            : `<span class="s-docs docs-not-ok">${
              proposta.files.length <= 0 && proposta.customer.files.length <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }</span>`
      }
    });
    data.sales.map(proposta => {
      proposta.faixas =
        proposta.convenet.receipt_settings &&
        proposta.convenet.receipt_settings.length > 0
          ? `<select class="indiv-selects" >
              ${proposta.convenet.receipt_settings[
            indexPrimeroRepasse
            ].comissions.map(
          comission => `
                  <option value='${comission.description}$SEP#VALUE$${
            comission.amount
          }$SEP#VALUE$${comission.percent}'>${
            comission.description
              ? comission.description
              : "FAIXA DESCONHECIDA"
          }</option>
                `
          )}
             </select>`
          : `<select class="indiv-selects" >
            <option value='FAIXA DESCONHECIDA$SEP#VALUE$0$SEP#VALUE$0'>
              FAIXA DESCONHECIDA
          </option>
          </select>`;
      proposta.percent =
        proposta.convenet.receipt_settings &&
        proposta.convenet.receipt_settings.length > 0
          ? proposta.convenet.receipt_settings[indexPrimeroRepasse].comissions[indexPrimeroRepasse]
          ? proposta.convenet.receipt_settings[indexPrimeroRepasse].comissions[indexPrimeroRepasse]
            .percent
          : 0
          : 0;
      proposta.value_repasse =
        proposta.convenet.receipt_settings &&
        proposta.convenet.receipt_settings.length > 0
          ? proposta.convenet.receipt_settings[indexPrimeroRepasse].comissions[indexPrimeroRepasse]
          ? proposta.convenet.receipt_settings[indexPrimeroRepasse].comissions[indexPrimeroRepasse]
            .amount !== null
            ? proposta.convenet.receipt_settings[indexPrimeroRepasse]
              .comissions[indexPrimeroRepasse].amount
            : 0
          : 0
          : 0;
      proposta.total_repasse =
        proposta.convenet.receipt_settings &&
        proposta.convenet.receipt_settings.length > 0
          ? proposta.convenet.receipt_settings[indexPrimeroRepasse].comissions[indexPrimeroRepasse]
          ? formatReal(
            parseFloat(
              proposta.convenet.receipt_settings[indexPrimeroRepasse]
                .comissions[indexPrimeroRepasse].amount !== null
                ? proposta.convenet.receipt_settings[indexPrimeroRepasse]
                  .comissions[indexPrimeroRepasse].amount
                : 0
            ) +
            (proposta.convenet.receipt_settings[indexPrimeroRepasse]
                .comissions[indexPrimeroRepasse].percent /
              100) *
            proposta.value_base
          )
          : "0,00"
          :  "0,00";
      proposta.value_base_formated = proposta.value_base
        ? formatReal(proposta.value_base)
        : "0,00";
      proposta.total_receipted_formated = proposta.total_receipted
        ? formatReal(proposta.total_receipted)
        : "0,00";
      proposta.multiplier_formated = proposta.multiplier
        ? formatReal(proposta.multiplier)
        : "0,00";
      return proposta;
    });
    yield put(
      GerarRepassesActions.getGerarRepassesSuccess(data, faixas_selects)
    );
    const {action} = yield select(state => state.gerarRepassesStores);
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalActions.open());
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/gerarRepasses.js